module.exports = __webpack_public_path__ + "img/certificate_bv_iso_9001_2015.8de86bca.png";